module.exports = __webpack_public_path__ + "img/vip_button.a31ce963.png";